/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  box-sizing: border-box;
  display: grid;
  contain: content;
  min-height: 100%;
}
:host svg {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
:host svg .label {
  font-weight: 400;
  font-size: 0.7rem;
}
:host > svg {
  margin-left: 1rem;
  width: calc(100% - 2rem);
}
:host > davinci-legend {
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

:host([hidden]) {
  display: none;
}

circle {
  stroke: #EEEFF0;
  stroke: var(--davinci-color-background-3, #EEEFF0);
}`;
export { style };
